module.exports = __webpack_public_path__ + "static/media/Agri-Entrepreneur Infographic Mobile 20-12-2023 .02247721.gif";